import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${Spacing.S8};
  margin-bottom: -${Spacing.S8};
  > * {
    flex: 1;
  }
`
